import React from 'react'

import FiltersTag from './FiltersTag'

import { useGetInfo, useMainCategories } from '../../../hooks'

import getFindTutorFilters from '../../../helpers/getFindTutorFilters'

import { tutorClassLevels, tutorPrices, tutorRatings } from './data'
import { suitableTimes } from '../../../constants'

const FiltersTags = ({ filters, onChangeFilters }) => {
  const { formattedWorldLanguages, formattedWorldTimezones, formattedCountries } = useGetInfo()
  const categories = useMainCategories()

  const currentFilters = getFindTutorFilters(filters)

  const selectedCategory = categories.find(
    (category) => category.slug === currentFilters.class_banner_category
  )
  const search = filters.search
  const selectedLanguage = formattedWorldLanguages.find(
    (language) => language.value === currentFilters.languages
  )
  const selectedPrice = tutorPrices.find(
    (price) => price.value === currentFilters.price_per_class__range
  )
  const selectedRating = tutorRatings.find(
    (rating) => rating.value === currentFilters.overall_rating__range
  )
  const selectedClassLevel = tutorClassLevels.find(
    (classLevel) => classLevel.value === currentFilters.class_banner_level
  )
  const selectedTimezone = formattedWorldTimezones.find(
    (timezone) => timezone.value === currentFilters.timezone
  )
  const selectedTimePreferences = suitableTimes.find(
    (suitableTime) => suitableTime.value === currentFilters.time_preferences
  )
  const selectedOriginCountry = formattedCountries.find(
    (country) => country.value === currentFilters.country_of_origin
  )
  const selectedResidenceCountry = formattedCountries.find(
    (country) => country.value === currentFilters.country_of_residence
  )

  const handleResetCategory = () => {
    onChangeFilters('class_banner_category', '_')
  }

  const handleResetSearch = () => {
    onChangeFilters('search', '')
  }

  const handleResetLanguage = () => {
    onChangeFilters('languages', '_')
  }

  const handleResetPrice = () => {
    onChangeFilters('price', '_')
  }

  const handleResetRating = () => {
    onChangeFilters('rating', '_')
  }

  const handleResetClassLevel = () => {
    onChangeFilters('class_banner_level', '_')
  }

  const handleResetTimezone = () => {
    onChangeFilters('timezone', '_')
  }

  const handleResetTimePreferences = () => {
    onChangeFilters('time_preferences', '')
  }

  const handleResetOriginCountry = () => {
    onChangeFilters('country_of_origin', '_')
  }

  const handleResetResidenceCountry = () => {
    onChangeFilters('country_of_residence', '_')
  }

  return (
    <section aria-labelledby="active-filters-heading" className="flex items-start mt-[24px] w-full">
      <h2
        id="active-filters-heading"
        className="text-[18px] font-bold leading-[30px] text-[#FDFDFD] mt-[2px] mr-[10px]"
      >
        Filter:
      </h2>

      <ul className="flex items-start flex-wrap gap-[10px]">
        {!!selectedCategory && (
          <FiltersTag text={selectedCategory.name} onDelete={handleResetCategory} />
        )}

        {!!search && <FiltersTag text={`keyword: ${search}`} onDelete={handleResetSearch} />}

        {!!selectedLanguage && (
          <FiltersTag text={selectedLanguage.label} onDelete={handleResetLanguage} />
        )}

        {!!selectedPrice && <FiltersTag text={selectedPrice.label} onDelete={handleResetPrice} />}

        {!!selectedRating && (
          <FiltersTag text={selectedRating.label} onDelete={handleResetRating} />
        )}

        {!!selectedClassLevel && (
          <FiltersTag text={selectedClassLevel.label} onDelete={handleResetClassLevel} />
        )}

        {!!selectedTimezone && (
          <FiltersTag text={selectedTimezone.label} onDelete={handleResetTimezone} />
        )}

        {!!selectedTimePreferences && (
          <FiltersTag text={selectedTimePreferences.label} onDelete={handleResetTimePreferences} />
        )}

        {!!selectedOriginCountry && (
          <FiltersTag text={selectedOriginCountry.label} onDelete={handleResetOriginCountry} />
        )}

        {!!selectedResidenceCountry && (
          <FiltersTag
            text={selectedResidenceCountry.label}
            onDelete={handleResetResidenceCountry}
          />
        )}
      </ul>
    </section>
  )
}

export default FiltersTags
